<template>  
    <SimulationDetailDrawer v-if="isSimulation" />  
    <CoverageDetailDrawer v-else-if="isCoverage || isFormation" />    
</template>
<script lang="ts">


import SimulationDetailDrawer from '@/components/smart/SimulationDetailDrawer.vue'
import CoverageDetailDrawer from '@/components/smart/Coverage/CoverageDetailDrawer.vue'

import Vue from 'vue'
import Component from 'vue-class-component'
import { isAloDbMissionGlobalCoverage, isAloDbMissionGlobalFormation, isAloDbMissionGlobalSimulation } from '@/models/alodb/AloDbMissionGlobal'
 
@Component({
name: 'SmartDetailDrawer',
components:{SimulationDetailDrawer,CoverageDetailDrawer}
})
export default class SmartDetailDrawer extends Vue {      
   
 
 get missionGlobal(){
   return this.$store.myGetters.originalAdmMissionGlobal
 }


 get isSimulation()
 {
    return isAloDbMissionGlobalSimulation(this.missionGlobal)
 }

 get isCoverage()
 {
    return isAloDbMissionGlobalCoverage(this.missionGlobal)
 }

 get isFormation()
 {
    return isAloDbMissionGlobalFormation(this.missionGlobal)
 }
 
}
</script> 

